import { useState, useCallback } from 'react';

export type J212Mode = 'browse' | 'add' | 'edit';

export function useJ212Mode() {
  const [mode, setMode] = useState<J212Mode>('browse');

  const enterAdd = useCallback(() => setMode('add'), []);
  const enterEdit = useCallback(() => setMode('edit'), []);
  const enterBrowse = useCallback(() => setMode('browse'), []);

  const isEditing = mode === 'add' || mode === 'edit';

  return { mode, isEditing, enterAdd, enterEdit, enterBrowse };
}
